import { ApolloClient, InMemoryCache, HttpLink } from "@apollo/client";

// Configure Apollo Client for login requests
const loginClient = new ApolloClient({
  link: new HttpLink({
    uri: "https://api.learnhut.de/auth/login", // Correct endpoint without :8081 if Nginx forwards
    credentials: "include", // Include cookies or credentials
  }),
  cache: new InMemoryCache(),
});

export default loginClient;
